import { API } from 'aws-amplify';
import React from 'react';
import { UserAPI } from '../config';
import { ActivityProps, ActivityType, Payload } from '../shared/Activity'


const LogActivityWithoutHook = async (activityType: ActivityType, payload?: Payload) => {
    //const body: ActivityProps = { activityType, payload }
    //await API.post(UserAPI, '/activity', { body })
}

const LogActivity = (activityType: ActivityType, payload?: Payload) => React.useEffect(() => {
    (async () => {
        //const body: ActivityProps = { activityType, payload }
        //await API.post(UserAPI, '/activity', { body })
    })()
}, [])


export default { LogActivity, LogActivityWithoutHook}